import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        sales: [],
        sales_team: null,
    },
    mutations: {
        loadSales(state, payload) {
			state.sales = payload
		},
        loadTeamSales(state, payload) {
			state.sales_team = payload
		},
        addSales(state, payload) {
            let index = state.sales.length
			Vue.set(state.sales, index, payload)   
        },
        addTeamSales(state, payload) {
            let index = state.sales_team.length
			Vue.set(state.sales_team, index, payload)   
        },
        editSales(state, payload) {
            const prod = state.sales.find(s => s.id == payload.id)
            const index = state.sales.indexOf(prod)
			Vue.set(state.sales, index, payload)   
        },
        deleteSales(state, payload) {
            state.sales =  state.sales.filter(s => s.id !== payload)
        }
    },
    actions: {
        //fetch all sales by game id & round
        async fetchSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/sales/game/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const prods = result.data 
                   commit('loadSales', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchTeamSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const teamId = payload.teamId;
            const gameId = payload.gameId;
            const round = payload.round;
            
            try {
                const result = await http.get(`/sales/team/${teamId}?gameId=${gameId}&round=${round}`);
                
                if (result && result.data) {
                   const sales = result.data 
                   commit('loadTeamSales', sales) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            const trademark = {};

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademark) {
                team = payload.trademark;
                delete payload.trademark;
            }

            try {
                const result = await http.post(`/sales`, payload);
                
                if (result) {
                    const sales = await result.data;
                    sales.team = team;
                    sales.trademark = trademark;
                    commit('addSales', sales)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            let team = {};
            let trademark = {};

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademark) {
                trademark = payload.trademark;
                delete payload.trademark;
            }

            try {
                await http.put(`/sales/${payload.id}`, payload);

                payload.team = team;
                payload.trademark = trademark;
                
                commit('editSales', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.delete(`/sales/${payload}`);
                console.log(result)
                commit('deleteSales', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/sales/calculate/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const prods = result.data 
                   commit('loadSales', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        sales(state) {
            return state.sales;
        },
        sales_team(state) {
            return state.sales_team;
        }
    }
}